export default "__VITE_ASSET__zwyddrSs__"